module.exports = __webpack_public_path__ + "img/drh5_icon_line.e1287251.png";